import { render } from "./MagentoCustomDevelopment.vue?vue&type=template&id=fa8dcfb0"
import script from "./MagentoCustomDevelopment.vue?vue&type=script&lang=js"
export * from "./MagentoCustomDevelopment.vue?vue&type=script&lang=js"

import "./MagentoCustomDevelopment.vue?vue&type=style&index=0&id=fa8dcfb0&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__